<template>
	<div class="address-option" :class="{ 'is-selected': selected == method.id }" @click.prevent="$emit('update:selected', method.id)">
		<div class="option-indicator">
			<i :class="`${selected == method.id ? 'far fa-check-circle' : 'far fa-circle'}`"/>
		</div>

		<div class="option-info">
			<div class="info-name">{{ method.name || cardInfo }}</div>
			<div class="info-address">
				{{ cardInfo }}<br>
				{{ method.street1 }} {{ method.street2 }}<br>
				{{ method.city }} {{ method.region }} {{ method.postal_code }}
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash/string';

export default {
	props: {
		method: { required: true },
		selected: { default: '' },
	},

	computed: {
		cardInfo()
		{
			return `${_.capitalize(this.method.card_type)} / **** ${this.method.last4}`
		},
	}
}
</script>